function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1538.7 0L1250 500 961.3 0H0l1250 2165.1L2500 0z",
  fill: "#4dba87"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1538.7 0L1250 500 961.3 0H500l750 1299L2000 0z",
  fill: "#435466"
});

function SvgVuelogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2500 2165.1",
    width: 56
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAyNTAwIDIxNjUuMSIgdmlld0JveD0iMCAwIDI1MDAgMjE2NS4xIiB3aWR0aD0iNTZweCIKICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Im0xNTM4LjcgMC0yODguNyA1MDAtMjg4LjctNTAwaC05NjEuM2wxMjUwIDIxNjUuMSAxMjUwLTIxNjUuMXoiIGZpbGw9IiM0ZGJhODciLz4KICA8cGF0aCBkPSJtMTUzOC43IDAtMjg4LjcgNTAwLTI4OC43LTUwMGgtNDYxLjNsNzUwIDEyOTkgNzUwLTEyOTl6IiBmaWxsPSIjNDM1NDY2Ii8+Cjwvc3ZnPg==";
export { SvgVuelogo as ReactComponent };